import cx from 'clsx';

import {
  MantineTheme,
  PaginationFactory,
  PartialVarsResolver,
  rem
} from '@mantine/core';

import { PaginationProps } from './Pagination';
import classes from './Pagination.module.css';

export const DefaultPaginationProps: Partial<PaginationProps> = {
  size: 'lg'
};

export const PaginationOverrideClassnames = (
  theme: MantineTheme,
  props: PaginationProps
) => {
  return {
    root: classes.root,
    control: cx(classes.control, {
      [classes.primaryControl]: props.color === 'primary' || !props.color
    })
  };
};

export const PaginationVarsResolver: PartialVarsResolver<PaginationFactory> = (
  theme: MantineTheme,
  props: PaginationProps
) => {
  if (props.size === 'xs') {
    return {
      root: {
        '--pagination-control-fz': rem(10),
        '--pagination-control-size': rem(20)
      }
    };
  } else if (props.size === 'sm') {
    return {
      root: {
        '--pagination-control-fz': rem(12),
        '--pagination-control-size': rem(24)
      }
    };
  } else if (props.size === 'md') {
    return {
      root: {
        '--pagination-control-fz': rem(12),
        '--pagination-control-size': rem(28)
      }
    };
  } else if (props.size === 'lg') {
    return {
      root: {
        '--pagination-control-fz': rem(13),
        '--pagination-control-size': rem(32)
      }
    };
  } else if (props.size === 'xl') {
    return {
      root: {
        '--pagination-control-fz': rem(14),
        '--pagination-control-size': rem(40)
      }
    };
  } else {
    return {
      root: {
        '--pagination-control-fz': rem(12),
        '--pagination-control-size': rem(28)
      }
    };
  }
};
